import Tab from "react-bootstrap/Tab";

//*componente

//*interfaces
interface PropsMenuV {
  menu: any;
}
export default function ParteContenido(props: PropsMenuV) {
  let menu = props.menu;
  return (
    <div id="idcont">
      <Tab.Content>
        {menu.map((item: any, key: any) => (
          <Tab.Pane eventKey={item.id}>contenido {item.desc}</Tab.Pane>
        ))}
      </Tab.Content>
    </div>
  );
}
